<template>
    <div v-if="comments.length > 0">
        <div class="comment" v-for="comment in comments" v-bind:key="comment.id">
            <div class="small">
                <strong>{{ comment.author.name }}</strong> {{ comment.created_at }}
            </div>

            {{ comment.comment }}
        </div>
    </div>
    <div v-else class="alert alert-secondary">
        Нет комментариев
    </div>
</template>

<script>
export default {
  props: {
    comments: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
    .comment {
        margin-bottom: 10px;
    }
</style>
